import React from "react";

import { Helmet } from "react-helmet";

const FontsHelmet = () =>
  (
    <Helmet>
      {/* Styles are also included in src/styles for faster load */}
      {/* But don't remove them from here: licenses are critical in all pages head */}
      <script type="text/javascript">
        {`/**
          * @license
          * MyFonts Webfont Build ID 313421
          *
          * The fonts listed in this notice are subject to the End User License
          * Agreement(s) entered into by the website owner. All other parties are
          * explicitly restricted from using the Licensed Webfonts(s).
          *
          * You may obtain a valid license from one of MyFonts official sites.
          * http://www.fonts.com
          * http://www.myfonts.com
          * http://www.linotype.com
          */`}
      </script>
      <link rel="stylesheet" href="/fonts/GilroyBold/MyFontsWebfontsKit.css" type="text/css" />

      <script type="text/javascript">
        {`/**
          * @license
          * MyFonts Webfont Build ID 450889
          *
          * The fonts listed in this notice are subject to the End User License
          * Agreement(s) entered into by the website owner. All other parties are
          * explicitly restricted from using the Licensed Webfonts(s).
          *
          * You may obtain a valid license from one of MyFonts official sites.
          * http://www.fonts.com
          * http://www.myfonts.com
          * http://www.linotype.com
          */`}
      </script>
      <link rel="stylesheet" href="/fonts/GilroyMedium/MyFontsWebfontsKit.css" type="text/css" />

      <script type="text/javascript">
        {`/**
          * @license
          * MyFonts Webfont Build ID 248572
          *
          * The fonts listed in this notice are subject to the End User License
          * Agreement(s) entered into by the website owner. All other parties are
          * explicitly restricted from using the Licensed Webfonts(s).
          *
          * You may obtain a valid license from one of MyFonts official sites.
          * http://www.fonts.com
          * http://www.myfonts.com
          * http://www.linotype.com
          */`}
      </script>
      <link rel="stylesheet" href="/fonts/GilroyRegular/MyFontsWebfontsKit.css" type="text/css" />

      <script type="text/javascript">
        {`/**
          * @license
          * MyFonts Webfont Build ID 906702
          *
          * The fonts listed in this notice are subject to the End User License
          * Agreement(s) entered into by the website owner. All other parties are
          * explicitly restricted from using the Licensed Webfonts(s).
          *
          * You may obtain a valid license from one of MyFonts official sites.
          * http://www.fonts.com
          * http://www.myfonts.com
          * http://www.linotype.com
          */`}
      </script>
      <link rel="stylesheet" href="/fonts/GilroyRegularItalic/MyFontsWebfontsKit.css" type="text/css" />

      <script type="text/javascript">
        {`/**
          * @license
          * MyFonts Webfont Build ID 275920
          *
          * The fonts listed in this notice are subject to the End User License
          * Agreement(s) entered into by the website owner. All other parties are
          * explicitly restricted from using the Licensed Webfonts(s).
          *
          * You may obtain a valid license from one of MyFonts official sites.
          * http://www.fonts.com
          * http://www.myfonts.com
          * http://www.linotype.com
          */`}
      </script>
      <link rel="stylesheet" href="/fonts/GilroySemiBold/MyFontsWebfontsKit.css" type="text/css" />

      <script type="text/javascript">
        {`/**
          * @license
          * MyFonts Webfont Build ID 404664
          *
          * The fonts listed in this notice are subject to the End User License
          * Agreement(s) entered into by the website owner. All other parties are
          * explicitly restricted from using the Licensed Webfonts(s).
          *
          * You may obtain a valid license from one of MyFonts official sites.
          * http://www.fonts.com
          * http://www.myfonts.com
          * http://www.linotype.com
          */`}
      </script>
      <link rel="stylesheet" href="/fonts/GilroyUltraLight/MyFontsWebfontsKit.css" type="text/css" />
    </Helmet>
  );

export default FontsHelmet;
